import { api } from "./client";

export interface Company {
  id: string;
  name: string;
  email: string;
  plan: string;
  created_at: string;
}

export const companiesApi = {
  list: () => api.get<Company[]>("/api/companies"),
};
